import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { CheckingAccountTotalsResponseDTO, ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetClientsCheckingAccountTotalsCommand extends IRequestCommand<CheckingAccountTotalsResponseDTO,
  ErrorDetails,
  IGetClientsCheckingAccountTotalsCommandParameters> {
  override _commandType: CommandRequestType = CommandRequestType.GET;

  public override setParameters(parameters: IGetClientsCheckingAccountTotalsCommandParameters) {
    this.urlSections.push('checking-accounts');
    this.urlSections.push('carrier');
    this.urlSections.push(`${parameters.carrierId}`);
    this.urlSections.push('clients');
    this.urlSections.push('totals');
    this.composeUrl();
  }
}

export interface IGetClientsCheckingAccountTotalsCommandParameters {
  carrierId: number;
}

